<core-discussion-chat
  #chatFeed
  [activeDiscussion]="activeDiscussion()"
  [decoratedMessages]="decoratedMessages()"
  [isLoadingMessages]="isLoadingMessages()"
  [isLoadingMore]="isLoadingMore()"
  [timeFormat]="timeFormat()"
  [showDeletePipe]="showDeletePipe"
  [subtitle]="'En ligne • Candidature en cours'"
  [participantNameResolver]="getParticipantName"
  [participantInitialResolver]="getParticipantInitial"
  [clickableProfile]="true"
  [participantAvatarUrl]="participantAvatarUrl()"
  [pinnedMessage]="pinnedMessage()"
  [pendingActions]="resolvedPendingActions()"
  (pendingActionClick)="actionClick.emit($event)"
  (actionMessageClick)="onActionMessageClick($event)"
  (profileClick)="openParticipantProfileModal()"
  (sendMessage)="sendMessage.emit($event)"
  (copyMessageText)="copyMessageText.emit($event)"
  (pinMessage)="pinMessage.emit($event)"
  (infoMessage)="infoMessage.emit($event)"
  (deleteMessage)="deleteMessage.emit($event)"
  (scrolledToTop)="scrolledToTop.emit()"
  (readActiveDiscussion)="readActiveDiscussion.emit()"
  (unpinMessage)="unpinMessage.emit()"
  (retryMessage)="retryMessage.emit($event)"
>
  <!-- ETXE actions in header -->
  @if (activeDiscussion()?.context?.property) {
    <a
      chat-header-actions
      [routerLink]="['/properties', $safeNavigationMigration(activeDiscussion()?.context?.property)]"
      mat-stroked-button
      class="!px-4 !py-1 text-xs font-bold text-primary hover:bg-primary-9/10"
    >
      Voir le bien
    </a>
  }

  <!-- ETXE specific empty state text -->
  <div
    chat-unselected-state
    class="flex-1 flex flex-col items-center justify-center text-center p-8 text-neutral-10"
  >
    <div
      class="size-20 rounded-full bg-white dark:bg-neutral-2 border border-neutral-3 flex items-center justify-center mb-4"
    >
      <mat-icon class="size-10 text-4xl text-neutral-8">forum</mat-icon>
    </div>
    <h2 class="text-xl font-bold text-neutral-12 mb-1">Vos messages</h2>
    <p class="text-sm max-w-sm">
      Sélectionnez une discussion à gauche pour commencer à échanger avec un propriétaire.
    </p>
  </div>
</core-discussion-chat>
